import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import { DealerRequestModel, DealerViewModel } from '../../../business-entities/dealer-view-model';
import { MechanicInOutOverTimeRequestModel } from '../../../business-entities/mechanic-clocking-time-request-model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { AppointmentPlanningService } from '../../../business-services/appointment-planning.service';
import { MechanicService } from '../../../business-services/mechanic.service';
import { MechanicList } from '../../../business-entities/mechanicList-model';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { AfMechanicSchedulerListComponent } from '../../../components/af-mechanic-scheduler-list/af-mechanic-scheduler-list.component';
@Component({
  selector: 'app-mechanic-clocking-time',
  templateUrl: './mechanic-clocking-time.component.html',
  providers: [AfMechanicSchedulerListComponent] 
})
export class MechanicClockingTimeComponent implements OnInit {
  dealerList: DealerViewModel[];
  mechanicList: MechanicList[];
  userRoleRightsDetails: UserRoleMenu;
  isMechanicSelected: boolean = false;
  dealers: DealerViewModel[] = [];
  mechanicId: number = 0;
  dealerId: string = null;
  ExportExcelMapData:any;
  id: string = '0';
  isHoliday: boolean;
  isRequired: boolean;
  isMechanicNotAssociated: boolean = false;
  selecteMechanic = 0;
  isShowAll: boolean = true;
  selectedDate = new Date();
  schedulerHeaderInfo: any;
  isSearched: boolean = false;
  dealerName: string = '';
  isErrorMessage: boolean = false;
  distinctMechanics: any[] = [];
  distinctMechanicId: any[] = [];
  mechanicData: any[] = [];
  dealerRequestModel: DealerRequestModel = {
    keyLocation: false,
    onlinePayment: false,
    isAdvanceSearch: false,
    statusId: 0,
    isAllDealer: false,
    isForList: false
  };
  constructor(
    public mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private appointmentPlanningService: AppointmentPlanningService,
    private userService: UserDataService,
    private excelService: ExcelService,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private mechanicSchedular: AfMechanicSchedulerListComponent,
  ) { }

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId ?? '';
    this.GetAll();
  }

  GetAll() {
    this.mechanicService.GetDealerList(this.dealerRequestModel).then(data => {
      this.dealerList = data.responseObject;
      for (let value of this.dealerList) {
        this.dealers.push(value);
      }
      if(this.dealerList.length === 1){
          this.dealerId = this.dealers[0].dealerId;
          this.GetMechanicList(this.dealerId);
      }
      else if(this.dealerId != ''){
        this.GetMechanicList(this.dealerId);
      }
    })
  }

  async getMechanicInOutOverTimeSummary(date?: Date) {
    this.spinner.show();
    if (date) {
      if (!isNaN(date.getTime())) {
        this.selectedDate = date;
      }
    }

    const getMechanicInOutOverTimeRequestModel: MechanicInOutOverTimeRequestModel = {
      userId: this.userService.currentUserValue.userId,
      dealerId: this.dealerId,
      mechanicId: this.mechanicId,
      year: new Date(this.selectedDate).getFullYear(),
      month: new Date(this.selectedDate).getMonth() + 1,

    }

    await this.appointmentPlanningService.getMechanicInOutOverTime(getMechanicInOutOverTimeRequestModel)
      .then(result => {
        const responseObject = result.responseObject;
        if (responseObject && responseObject.errorCount > 0) {
          this.spinner.hide();
          this.mechanicData = [];
          this.isMechanicNotAssociated = true;
        }
        else {
          this.schedulerHeaderInfo = responseObject;
          this.distinctMechanicId = [...new Set(this.schedulerHeaderInfo.map(obj => obj.mechanicId))];
          let arrList = [];
          this.distinctMechanicId.forEach(mechanicId => {
            const mechanicData = this.schedulerHeaderInfo.filter(x => x.mechanicId === mechanicId);
            if (mechanicData?.length > 0) {
              arrList.push({
                mechanicId: mechanicId,
                mechanicName: mechanicData[0].mechanicName,
                inTime: mechanicData.map(x => (x.inTime != null ? new Date(x.inTime + 'Z') : '-')),
                outTime: mechanicData.map(x => (x.outTime != null ? new Date(x.outTime + 'Z') : '-')),
                actualInTime: mechanicData.map(x => x.actualInTime),
                totalHours: mechanicData.map(x => x.totalHours),
                shiftHours: mechanicData.map(x => x.shiftHours),
                overTime: mechanicData.map(x => x.overTime),
                isHoliday: mechanicData.map(x => x.isHoliday),
                isOnLeave: mechanicData.map(x => x.isOnLeave),
                isInActive: mechanicData.map(x => x.isInActive),
                lunchTime: mechanicData.map(x => x.lunchTime)
              });
            }
          })
          this.mechanicData = arrList;
        }
        this.spinner.hide();
      })

  }
  onRefresh() {
    this.getMechanicInOutOverTimeSummary();
  }

  scheduleSummaryMonthChange(date?: Date) {
    this.getMechanicInOutOverTimeSummary(date);
    this.spinner.hide();
  }

  onDealerChange(value) {

    if (value) {
      this.selectedDealer();
      this.isRequired = false;

    } else {
      this.isMechanicSelected = false;
      this.selecteMechanic = 0;
      this.mechanicList = [];
      this.mechanicId = 0;
      this.isRequired = true;
    }
  }
  selectedDealer() {
    this.isMechanicSelected = false;
    this.selecteMechanic = 0;
    this.GetMechanicList(this.dealerId);

  }

  async exportAsXLSX(date?: Date){ 
    this.spinner.show();
    if (date) {
      if (!isNaN(date.getTime())) {
        this.selectedDate = date;
      }
    }

    const getMechanicInOutOverTimeRequestModel: MechanicInOutOverTimeRequestModel = {
      userId: this.userService.currentUserValue.userId,
      dealerId: this.dealerId,
      mechanicId: this.mechanicId,
      year: new Date(this.selectedDate).getFullYear(),
      month: new Date(this.selectedDate).getMonth() + 1, 
    }

    await this.appointmentPlanningService.getMechanicInOutOverTime(getMechanicInOutOverTimeRequestModel)
      .then(result => {
        const responseObject = result.responseObject;
        if (responseObject && responseObject.errorCount > 0) {
          this.spinner.hide();
          this.mechanicData = [];
          this.isMechanicNotAssociated = true;
        }
        else {
          this.schedulerHeaderInfo = responseObject; 
          const tableDataWithTotals = this.addTotalRow(responseObject);
          this.ExportExcelMapData = this.ExcelDataMapping(responseObject);
          this.ExportExcelMapData = [...this.ExportExcelMapData, tableDataWithTotals]
          const columnWidths =  [100, 200, 75, 75, 75, 85, 75, 90];
          this.excelService.exportAsExcelFile(this.ExportExcelMapData, 'Mechanic clocking time report', [], columnWidths);
        }
        this.spinner.hide();
      }) 
  }

  ExcelDataMapping(data: any[]) {
    return data.map(item => ({
      [this.translate.instant('lblDate')]: this.datePipe.transform(item.monthOfDate, 'dd-MM-yyyy', '', 'en-US'),
      [this.translate.instant('lblMechanicName')]: item.mechanicName,
      [this.translate.instant('lblInTime')]: item.inTime+'Z' || '-',
      [this.translate.instant('lblOutTime')]: item.outTime+'Z' || '-',
      [this.translate.instant('lblTotalHours')]: item.totalHours || '-',
      [this.translate.instant('lblActualInTime')]: item.actualInTime || '-',
      [this.translate.instant('lblShiftHours')]: item.shiftHours || '00:00',
      [this.translate.instant('lblOvertime')]: item.overTime || '-',
    }));
  }

  addTotalRow(data: any[]) {
    const totalHoursDatainRow = this.mechanicSchedular.totalHours(data.map(item => item.totalHours));
    const totalHoursData = this.mechanicSchedular.totalHours(data.map(item => item.shiftHours));
    const totalOverTimeData = this.mechanicSchedular.totalOverTime({ overTime: data.map(item => item.overTime) });
    const totalActualInTimeData = this.mechanicSchedular.totalActualInTime({ actualInTime: data.map(item => item.actualInTime) });
   
    const totalCalulation = {
      [this.translate.instant('lblDate')]: "Total",
      [this.translate.instant('lblMechanicName')]: '-',
      [this.translate.instant('lblInTime')]: '-',
      [this.translate.instant('lblOutTime')]: '-',
      [this.translate.instant('lblTotalHours')]: totalHoursDatainRow,
      [this.translate.instant('lblActualInTime')]: totalActualInTimeData,
      [this.translate.instant('lblShiftHours')]: totalHoursData,
      [this.translate.instant('lblOvertime')]: totalOverTimeData,
    }
    return totalCalulation;
  } 
 
  async GetMechanicList(id: string) {
    this.spinner.show();
    await this.mechanicService.GetMechanicList(id, Enums.StatusCode.Active).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.mechanicList = response.responseObject;
      }
      this.spinner.hide();
    });
  }
  selectedMechanic(e: any) {
    this.isMechanicSelected = true;
    e = e.split(':');
    this.mechanicId = e[1];
    if (this.mechanicId && this.mechanicId > 0) {
      this.isSearched = true;
      this.isRequired = false;
      this.dealerName = this.dealers.filter(x => x.dealerId === this.dealerId)[0]?.name;
      this.getMechanicInOutOverTimeSummary();
    }
  }
}
